var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngelDoubleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0434 11.7504L14.0434 11.7505L14.0465 11.7536C14.201 11.9081 14.1693 12.0986 14.0679 12.1888L14.0552 12.2L14.0434 12.2121L5.56841 20.8371L5.55054 20.8553L5.53461 20.8752C5.50536 20.9117 5.44504 20.95 5.32505 20.95C5.19929 20.95 5.11362 20.9065 5.0786 20.8715C4.93636 20.7292 4.93636 20.5208 5.0786 20.3786L5.07862 20.3786L5.08192 20.3752L12.9569 12.3502L13.3006 12L12.9569 11.6498L5.08192 3.6248L5.08194 3.62479L5.0786 3.62145C4.93636 3.47922 4.93636 3.2708 5.0786 3.12856C5.22043 2.98674 5.42804 2.98632 5.57025 3.12732L14.0434 11.7504Z",
    stroke: "inherit",
    fill: "none",
    strokeOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.275 11.4L10.8 2.77501C10.4625 2.43751 9.93755 2.43751 9.60005 2.77501C9.26255 3.11251 9.26255 3.63751 9.60005 3.97501L17.475 12L9.60005 20.025C9.26255 20.3625 9.26255 20.8875 9.60005 21.225C9.75005 21.375 9.97505 21.45 10.2 21.45C10.425 21.45 10.65 21.375 10.8 21.1875L19.275 12.5625C19.6125 12.2625 19.6125 11.7375 19.275 11.4Z",
    fill: "inherit",
    stroke: "none",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngelDoubleRight);
export default __webpack_public_path__ + "static/media/angel-double-right.455be9093fa67587b55d019f7ea7c7fe.svg";
export { ForwardRef as ReactComponent };